import cloneDeep from 'lodash/cloneDeep';

export const getList = (state) => {
  const list = cloneDeep(state.list);

  return list.map(item => {
    item.item_type = 'group';

    return item;
  });
}
